module.exports = __webpack_public_path__ + "static/img/IO.74bbaa38.svg";